const DOCUMENT = 'MARKETS_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadDataRequest: data => ({
    type: actions.LOAD_REQUEST,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
